import { CameraMiniaturePhotoContainer } from "../styled/File.style";

interface FotoPreviewItemProps {
    photo: any;
    badge: any;
}

const CameraFotoMiniatureItem = (props: FotoPreviewItemProps) => {
    const { badge, photo } = props
    return (
        <CameraMiniaturePhotoContainer>
            {badge}
            {photo}
        </CameraMiniaturePhotoContainer>
    )
}

export default CameraFotoMiniatureItem